<template>
  <div>
    <GlassCard class="mb-5 py-3">
      <!-- Description -->
      <div v-if="!template.secondaryTheme" class="col-sm-12 col-md-12 form-group pt-3 mt-2 mb-2">
        <p class="text-uppercase text-center text-white mb-0 login-title">
          {{ template.secondaryBtn.text }}
        </p>
      </div>

      <!-- Form -->
      <div class="p-2 m-2 form">
        <div class="col mb-4 d-flex justify-content-start">
          <i
            :style="
              currentStepIndex === 0 || finishedRegistration
                ? { color: 'transparent' }
                : { color: 'white' }
            "
            @click="goToPreviousStep"
            class="c-icon fa fa-arrow-left"
          />
        </div>

        <transition name="cardSlide" mode="out-in" tag="div">
          <!-- Registration Steps -->
          <component
            v-if="!finishedRegistration"
            :is="activeComponent"
            :validate="callForValidation"
            @validating="callForValidation = false"
            @next="getNextStep"
            @previous="goToPreviousStep"
          />

          <!-- Loading Screen -->
          <div v-else>
            <div
              class="text-center"
              v-if="!accountCreationMessage.length > 0 && registrationErrors.length < 1"
            >
              <LoadingRing />

              <p :style="template.secondaryTheme ? 'color: white;' : ''">
                {{ translation.waitRegisteringYourAccount }}
              </p>
            </div>
          </div>
        </transition>

        <!-- Success/Error Messages -->
        <div>
          <div class="col form-group my-3 error">
            <p
              class="text-center"
              style="font-size: 14px; text-align: center"
              :style="template.secondaryTheme ? 'color: white;' : ''"
            >
              {{ accountCreationMessage }}
            </p>

            <div v-if="registrationErrors.length" class="mb-1 mt-2 errorsDiv" color="#ffffff">
              <span
                v-for="(error, i) in registrationErrors"
                :key="i"
                :style="ownerId == 23 ? 'color: #fcff45;' : 'color: #fff;'"
                style="font-size: 11px; letter-spacing: 0.35px"
              >
                *
                {{
                  error.msg === 'Erro ao criar: Error: Network Error'
                    ? translation.accountCreationMessageNetworkError
                    : error.msg
                }}
              </span>
            </div>
          </div>
        </div>

        <!-- OptIn -->
        <div
          v-if="steps[0].includes(activeComponent)"
          class="col-sm-12 col-md-12 form-group pt-0 d-flex mb-n1"
        >
          <label class="c-checkbox-container">
            <input v-model="optIn" type="checkbox" checked />

            <span class="checkmark mt-1" />
          </label>

          <div class="terms-div">
            <label>
              <small :style="template.secondaryTheme ? 'color: white;' : ''">
                Concordo com a
                <a
                  @click="showModal = true"
                  target="_blank"
                  tag="a"
                  style="color: white; text-decoration: underline; cursor: pointer"
                >
                  Política de Privacidade
                </a>

                {{ translation.fromThisSite }}
              </small>
            </label>
          </div>
        </div>

        <!-- Submit Button -->
        <div class="col-sm-12 col-md-12 form-group pt-3">
          <button
            v-if="!finishedRegistration"
            type="submit"
            class="btn text-uppercase btn-block shadow-sm"
            :class="template.secondaryTheme ? 'back-login-secondary' : ''"
            style="font-size: small; font-weight: 600; letter-spacing: 1px"
            :style="primaryBtnStyle"
            @click="callForValidation = true"
          >
            {{ isLastStep ? template.secondaryBtn.text : translation.continue }}
          </button>
        </div>

        <!-- Cancel Button -->
        <div class="col-sm-12 col-md-12 form-group">
          <button
            v-if="
              accountCreationMessage.length > 0 &&
              registrationErrors.length < 1 &&
              config.faceBiometry
            "
            class="btn-block btn-dark btn shadow-sm text-uppercase"
            style="padding: 5px 0; font-size: small; letter-spacing: 1px"
            :style="secondaryBtnStyle"
            :disabled="processingApi"
            @click="continueToFaceBiometry()"
          >
            Continuar
          </button>

          <button
            v-else-if="accountCreationMessage.length > 0 && registrationErrors.length < 1"
            class="btn-block btn-dark btn shadow-sm text-uppercase"
            style="padding: 5px 0; font-size: small; letter-spacing: 1px"
            :style="secondaryBtnStyle"
            :disabled="processingApi"
            @click="continueAfterRegistration()"
          >
            {{ translation.continue }}
          </button>

          <button
            v-else
            class="btn-block btn-dark btn shadow-sm text-uppercase"
            style="
              padding: 5px 0;
              font-size: small;
              letter-spacing: 1px;
              font-weight: 600;
              margin-bottom: 40px;
            "
            :style="secondaryBtnStyle"
            :class="template.secondaryTheme ? 'back-login-secondary' : ''"
            :disabled="processingApi"
            @click="$router.push(goToHomePage)"
          >
            <i class="fa fa-caret-left"></i>
            {{ translation.backToLogin }}
          </button>
        </div>
        <div v-if="template.internalFooterLogin" class="col-sm-12 col-md-12 form-group">
          <div
            v-if="template.internalFooterLogin.logo"
            style="width: 100%; display: flex; justify-content: center; align-items: center"
          >
            <img
              :src="template.internalFooterLogin.logo"
              :width="template.internalFooterLogin.logowith"
            />
          </div>
          <div
            v-if="template.internalFooterLogin.showPoweredBy"
            style="
              height: 30px;
              margin-top: 5px;
              width: 100%;
              display: flex;
              justify-content: center;
              align-items: center;
            "
          >
            <div class="py-5">
              <small style="color: white; font-size: 0.55rem; text-transform: uppercase"
                >Powered by</small
              >

              <img
                class="ml-1"
                src="https://config.fanbase.com.br/prj/0/logo-white.png"
                width="45px"
              />
            </div>
          </div>
        </div>
      </div>
    </GlassCard>

    <SavedModal
      v-show="showModal"
      @close-modal="showModal = false"
      @open-modal="showModal = true"
    />
  </div>
</template>

<script>
/* Components */
import Name from '@/components/cadastro/Name.vue'
import FavoriteTeam from '@/components/cadastro/FavoriteTeam.vue'
import NameAndSocialName from '@/components/cadastro/NameAndSocialName.vue'
import CpfAndPhone from '@/components/cadastro/CpfAndPhone.vue'
import Phone from '@/components/cadastro/Phone.vue'
import Cep from '@/components/cadastro/Cep.vue'
import Email from '@/components/cadastro/Email.vue'
import EmailWithConfirmation from '@/components/cadastro/EmailWithConfirmation.vue'
import SavedModal from '@/components/ModalTerms.vue'
import GenderAndBirthDate from '@/components/cadastro/GenderAndBirthDate.vue'
import BirthDate from '@/components/cadastro/BirthDate.vue'
import Gender from '@/components/cadastro/Gender.vue'
import Password from '@/components/cadastro/Password.vue'
import Country from '@/components/cadastro/Country.vue'
import Passport from '@/components/cadastro/Passport.vue'
import Guardian from '@/components/cadastro/Guardian.vue'
import CpfVerification from '@/components/cadastro/CpfVerification.vue'
import Attribute from './cadastro/Attribute.vue'

/* State */
import { mapState, mapGetters, mapMutations } from 'vuex'

/* Helpers */
import { mask } from 'vue-the-mask'
import { getSSORedirectUrl } from '@/helpers/ssoHelper'

/* Services */
import { loginFB } from '../services/ServFB.js'

const lFB = new loginFB()

export default {
  name: 'Cadastro',
  components: {
    Name,
    FavoriteTeam,
    NameAndSocialName,
    EmailWithConfirmation,
    CpfAndPhone,
    SavedModal,
    Email,
    Cep,
    GenderAndBirthDate,
    Password,
    Country,
    Passport,
    Guardian,
    CpfVerification,
    Phone,
    Gender,
    BirthDate,
    Attribute,
  },
  mask: {
    ...mask,
    tokens: {
      ...mask.tokens,
      null: /./,
    },
  },
  data: () => ({
    activeComponent: '',
    callForValidation: false,
    IdentityNumber: 0,
    accountCreationMessage: '',
    returnedIdentity: null,
    finishedRegistration: false,
    processingApi: false,
    optIn: true,
    showModal: false,
    teamNumber: null,
    identity: null,
    toastMessage: '',
  }),
  computed: {
    ...mapGetters([
      'primaryBtnStyle',
      'secondaryBtnStyle',
      'primaryColorText',
      'getSelectedCountryId',
    ]),
    ...mapState([
      'template',
      'config',
      'registrationErrors',
      'registrationObject',
      'sso',
      'countries',
      'showInputCheckEmailGuardian',
    ]),
    steps() {
      if (!this.config) return []
      return this.config.registrationSteps
    },
    ownerId() {
      return this.config.ownerId
    },
    currentStepIndex() {
      if (this.steps) {
        return this.steps.indexOf(this.activeComponent)
      }
    },
    isLastStep() {
      // method to get an array containing the last element of the step's array
      let lastStep = this.steps.slice(-1)

      return lastStep.includes(this.activeComponent)
    },
    inviteToken() {
      return this.$route.query.inviteToken
    },
    translation() {
      if (this.countries.length) {
        return {
          error: 'Error',
          continue: 'Continue',
          backToLogin: 'Back to login',
          accountCreationMessage: 'Registration completed successfully!',
          accountCreationMessageError: 'We were unable to create your account.',
          accountCreationMessageNetworkError: 'Network error: please check your connection.',
          iAgreeWith: 'I agree with the',
          termsOfUse: 'Terms of Use and Privacy Policy',
          fromThisSite: 'from this site.',
          waitRegisteringYourAccount:
            'Please wait, we are registering your account. This may take a few seconds.',
        }
      }
      return {
        error: 'Error',
        continue: 'Avançar',
        backToLogin: 'Voltar para o login',
        accountCreationMessage: 'Cadastro efetuado com sucesso!',
        accountCreationMessageError: 'Não foi possível criar sua conta.',
        accountCreationMessageNetworkError: 'Erro de rede: Verifique sua conexão com a internet.',
        iAgreeWith: 'Concordo com os',
        termsOfUse: 'Termos de Uso e Política de Privacidade',
        fromThisSite: 'deste site.',
        waitRegisteringYourAccount:
          'Aguarde, estamos cadastrando sua conta. Isso poderá levar alguns segundos.',
      }
    },
    goToHomePage() {
      return getSSORedirectUrl(this.config)
    },
  },
  watch: {
    steps(newValue) {
      // if the user initializes the app directly into /cadastro,
      // we need to wait until the template isloaded
      // with the app.vue routine, then set the activeComponent
      this.activeComponent = newValue[0]
    },
  },
  created() {
    // These methods clear the store objects, then load the steps locally
    this.resetRegistrationObject()
    this.clearRegistrationErrors()

    this.steps = this.config.registrationSteps
    this.optIn = false
    this.activeComponent = this.steps[0]
    this.$store.dispatch('setCountries', [])
  },
  methods: {
    ...mapMutations([
      'resetRegistrationObject',
      'clearRegistrationErrors',
      'addRegistrationError',
      'setLoginByRegistration',
      'setShowInputCheckEmailGuardian',
    ]),
    makeToast(variant = null) {
      this.$bvToast.toast(this.toastMessage, {
        title: this.translation.error,
        variant: variant,
        solid: true,
      })
    },
    async createAccount() {
      this.processingApi = true

      let userInfo = this.registrationObject
      let ownerId = parseInt(this.config.ownerId)
      let team = userInfo.team + ''
      const defaultCountryCode = 31

      switch (ownerId) {
        case 20:
          //type para time de voleibol
          this.teamNumber = this.objForIdentity(10020, team)
          break
        case 24:
          //type para time de futebol
          this.teamNumber = this.objForIdentity(10024, team)
          break
        case 148:
          //type para time de basquete
          this.teamNumber = this.objForIdentity(10148, team)
          break
        case 11:
          //type para time de futsal
          this.teamNumber = this.objForIdentity(10011, team)
          break
        case 169:
          //type para federação de vela
          this.teamNumber = this.objForIdentity(10169, team)
          break
        default:
          this.teamNumber = this.objForIdentity(1000, team)
          break
      }

      let dataAccount = {
        Login: this.loginInfo(userInfo),
        Password: userInfo.password,
        IdentityNumber: 0,
        LoginType: parseInt(this.config.loginType),
        OwnerId: ownerId,
        SysId: parseInt(this.config.systemID),
        InviteToken: this.inviteToken,
        AttributesValues: userInfo.Attributes,
        Profile: {
          Name1: userInfo.firstName,
          Name2: userInfo.surname ? userInfo.surname : '',
          Gender: userInfo.gender,
          SocialName: userInfo.socialName ? userInfo.socialName : '',
          OriginSystemId: parseInt(this.config.systemID),
          Project: parseInt(this.config.prj),
          Birthdate: userInfo.birthDate,
          Numbers: [this.objForIdentity(3, userInfo.phone), this.objForIdentity(4, userInfo.email)],
        },
        Address: {
          Add1: userInfo.logradouro,
          Add2: userInfo.complement,
          Add3: userInfo.bairro,
          Number: userInfo.numero,
          Zip: userInfo.cep,
          City: userInfo.localidade,
          State: userInfo.uf ? userInfo.uf : userInfo.estado,
          Country: !userInfo.passport ? defaultCountryCode : this.getSelectedCountryId,
        },
      }

      if (userInfo.guardian) {
        dataAccount.guardian = {}
        dataAccount.guardian.Name1 = userInfo.guardian.firstName
        dataAccount.guardian.Name2 = userInfo.guardian.surname
        dataAccount.guardian.Cpf = userInfo.guardian.cpf
        dataAccount.guardian.Gender = userInfo.guardian.gender
        dataAccount.guardian.Phone = userInfo.guardian.phone
        dataAccount.guardian.Email = userInfo.guardian.email
        dataAccount.guardian.Degree = userInfo.guardian.degree
        dataAccount.guardian.BirthDate = userInfo.guardian.birthDate
      }

      if (userInfo.cpf) {
        dataAccount.Profile.Numbers.push(this.objForIdentity(1, userInfo.cpf))
      }

      if (userInfo.passport) {
        dataAccount.Profile.Numbers.push(this.objForIdentity(10, userInfo.passport))
        dataAccount.LoginType = 4
      }

      if (this.teamNumber.number !== 'undefined') {
        dataAccount.Profile.Numbers.push(this.teamNumber)
      }

      if (this.registrationObject.code) {
        dataAccount.Profile.Numbers.forEach(item => {
          if (item.numberType === 4) {
            item.verified = 1
          }
        })
      }

      if (!dataAccount.Address.Add1) dataAccount.Address = null

      lFB.createAccount(dataAccount).then(
        res => {
          this.accountCreationMessage = this.translation.accountCreationMessage
          this.toastMessage = this.accountCreationMessage
          this.makeToast('light')
          this.processingApi = false
          this.identity = res
          this.$store.commit('setIdentity', this.identity)
        },
        err => {
          this.accountCreationMessage = this.translation.accountCreationMessageError
          const errorMsg = `Erro ao criar: ${err}`
          this.addRegistrationError({
            msg: errorMsg,
          })
          this.toastMessage =
            errorMsg === 'Erro ao criar: Error: Network Error'
              ? this.translation.accountCreationMessageNetworkError
              : err
          this.makeToast('danger')
          this.processingApi = false
        },
      )
    },
    objForIdentity(type, value) {
      return {
        identity: 0,
        numberType: type,
        number: value,
        verified: null,
      }
    },
    getNextStep() {
      if (!this.optIn) {
        this.addRegistrationError({
          msg: 'É necessário aceitar a política de privacidade.',
        })

        return
      }

      if (this.isLastStep) {
        this.finishRegistration()
        return
      }

      this.activeComponent = this.steps[this.currentStepIndex + 1]
      if (this.activeComponent === 'Passport' && this.registrationObject.cpf) {
        this.getNextStep()
      }

      if (this.activeComponent === 'Guardian' && this.isOlderThan(16)) {
        this.getNextStep()
      }
      if (
        this.activeComponent === 'Email' &&
        this.steps[this.currentStepIndex + 1] === 'EmailWithConfirmation' &&
        this.isOlderThan(12)
      ) {
        this.getNextStep()
      }
      if (
        this.activeComponent === 'EmailWithConfirmation' &&
        this.steps[this.currentStepIndex - 1] === 'Email' &&
        !this.isOlderThan(12)
      ) {
        this.getNextStep()
      }
    },
    isOlderThan(minimumAge) {
      const birthDate = this.registrationObject.birthDate

      if (!birthDate) {
        return false
      }

      const [day, month, year] = birthDate.split('/').map(Number)

      if (isNaN(day) || isNaN(month) || isNaN(year)) {
        return false
      }

      const currentTime = new Date()
      const nowYear = currentTime.getFullYear()
      const nowMonth = currentTime.getMonth() + 1
      const nowDay = currentTime.getDate()

      let age = nowYear - year

      if (nowMonth < month || (nowMonth === month && nowDay < day)) {
        age--
      }

      return age >= minimumAge
    },
    goToPreviousStep() {
      if (this.activeComponent === 'Guardian' && this.showInputCheckEmailGuardian) {
        this.setShowInputCheckEmailGuardian(false)
      } else {
        this.activeComponent = this.steps[this.currentStepIndex - 1]
      }

      if (this.activeComponent === 'Passport' && this.registrationObject.cpf) {
        this.activeComponent = this.steps[this.currentStepIndex - 1]
      }

      if (this.activeComponent === 'Guardian' && this.isOlderThan(16)) {
        this.activeComponent = this.steps[this.currentStepIndex - 1]
      }

      if (
        this.activeComponent === 'Email' &&
        this.steps[this.currentStepIndex + 1] === 'EmailWithConfirmation' &&
        this.isOlderThan(12)
      ) {
        this.activeComponent = this.steps[this.currentStepIndex - 1]
      }
      if (
        this.activeComponent === 'EmailWithConfirmation' &&
        this.steps[this.currentStepIndex - 1] === 'Email' &&
        !this.isOlderThan(12)
      ) {
        this.activeComponent = this.steps[this.currentStepIndex - 1]
      }
      if (this.currentStepIndex === 0) {
        this.$store.dispatch('setCountries', [])
        return
      }

      this.clearRegistrationErrors()
    },
    finishRegistration() {
      this.clearRegistrationErrors()

      if (!this.optIn) {
        this.addRegistrationError({
          msg: 'É necessário aceitar os termos de uso.',
        })

        return
      }

      this.finishedRegistration = true

      this.createAccount()
    },
    continueAfterRegistration() {
      if (this.template.redirectRegister) {
        window.location.href = this.template.redirectRegister.link
      } else {
        this.$router.push(this.goToHomePage)
      }
    },
    continueToFaceBiometry() {
      this.setLoginByRegistration(true)

      this.$router.push('/FaceBiometry')
    },
    loginInfo(userInfo) {
      if (userInfo.cpf) {
        return this.config.loginType == 1 ? userInfo.cpf : userInfo.email
      }
      return userInfo.email
    },
  },
}
</script>

<style scoped>
.btn {
  height: 48px;
}

.c-icon:hover {
  color: var(--primary-color);
  cursor: pointer;
}

.cardSlide-enter-active {
  animation: slide-in 0.2s;
}

.cardSlide-leave-active {
  animation: slide-in 0.2s reverse;
}

@keyframes slide-in {
  0% {
    transform: translateX(10%);
    opacity: 0;
  }

  100% {
    transform: translateX(0%);
    opacity: 1;
  }
}

.customCheckbox {
  outline: 0px;
  border: 0px solid white;
}

.customCheckbox:checked {
  outline: 0px;
}

.login-title {
  font-size: 1.15rem !important;
  line-height: 24px;
}

.c-checkbox-container {
  font-size: 1rem;
  display: block;
  position: relative;
  z-index: 100;
  padding-left: 35px;
  margin-bottom: 12px;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.back-login-secondary {
  font-weight: bold;
  letter-spacing: -0.4px !important;
  font-size: 1.004rem !important;
}

/* Hide the browser's default checkbox */
.c-checkbox-container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* Create a custom checkbox */
.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 25px;
  width: 25px;
  border: 1px solid white;
  border-radius: 0.25rem;
  background-color: rgba(255, 255, 255, 0.1);
}

/* On mouse-over, add a grey background color */
.c-checkbox-container:hover input ~ .checkmark,
.c-checkbox-container:focus input ~ .checkmark {
  background-color: rgba(255, 255, 255, 0.2);
}

/* When the checkbox is checked, add a blue background */
.c-checkbox-container input:checked ~ .checkmark {
  background-color: var(--checkbox-color);
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
  content: '';
  position: absolute;
  display: none;
}

.terms-div {
  width: 200px;
}

/* Show the checkmark when checked */
.c-checkbox-container input:checked ~ .checkmark:after {
  display: block;
}

/* Style the checkmark/indicator */
.c-checkbox-container .checkmark:after {
  left: 9px;
  top: 5px;
  width: 5px;
  height: 10px;
  border: solid black;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}

.errorsDiv {
  display: flex;
  flex-direction: column;
  padding: 0;
}
</style>
